"use client"

import { useState } from 'react'
import { Link } from 'react-router-dom'
import AuthLayout from '@/components/auth/AuthLayout'
import { useForgotPassword } from '@/lib/api/hooks/auth'
import { showToast } from '@/lib/toast'
import { Button } from '@/components/ui/Button'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const forgotPasswordMutation = useForgotPassword()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSuccess(false)

    try {
      const response = await forgotPasswordMutation.mutateAsync(email)
      
      if (response.success) {
        setSuccess(true)
        showToast.success(response.message || 'Reset link has been sent to your email address')
        setEmail('') // Clear email field
      } else {
        setError(response.message || 'An error occurred while sending reset instructions')
      }
    } catch (error: unknown) {
      console.error('Password reset error:', error)
      const errorMessage = error instanceof Error 
        ? error.message 
        : (error as { response?: { data?: { message?: string } } })?.response?.data?.message
      setError(errorMessage || 'An error occurred while sending reset instructions')
    }
  }

  return (
    <AuthLayout>
      
      <div className="text-center mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2 font-satoshi">Forgot Password?</h2>
        <p className="text-gray-600 font-satoshi">Reset your password</p>
      </div>

     
      <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm font-satoshi">
              {error}
            </div>
          )}

          {success && (
            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm font-satoshi">
              Reset link has been sent to your email address. Please check your inbox and click the link to reset your password.
            </div>
          )}

        
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2 font-satoshi">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g. johndoe@gmail.com"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-forestGreen-100 focus:border-transparent outline-none transition-colors bg-white font-satoshi"
              required
            />
          </div>

         
          <Button
            type="submit"
            variant="primary"
            loading={forgotPasswordMutation.isPending}
            disabled={!email}
            className="w-full font-medium py-3 px-4 rounded-lg font-satoshi"
          >
            {forgotPasswordMutation.isPending ? 'Sending...' : 'Reset Password'}
          </Button>

        
          <div className="text-center">
            <Link to="/login" className="text-teal-600 hover:text-teal-700 text-sm font-medium font-satoshi">
              Sign In
            </Link>
          </div>
        </form>
    </AuthLayout>
  )
}

export default ForgotPassword